import React, { useState } from 'react';
import { useEvaluateList } from '../../../Hooks/Features/EvaluateList/useEvaluateList'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import PanelHeaderTemplate from '../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate'
import { MultiSelect } from 'primereact/multiselect'
import { Dropdown } from 'primereact/dropdown'
import { Dialog } from 'primereact/dialog'
import { useCommon } from '../../../Hooks/Common/useCommon'
import CommonGrid from '../../../components/CommonCompo/CommonGrid/CommonGrid'
import { ListBox } from 'primereact/listbox'
import { useTheme } from '../../../context/ThemeContext'

const EvaluateList = () => {
  const { theme } = useTheme();
  const { loader, colDef, rowData, showPopup, setShowPopup, options, formValue, setFormValue, handleChange, handleSubmit, filterValue, setFilterValue, getEvaluatorList, getExcelDownload, tagRef, optionTemplates, exclude, setExclude, saveExcludeUsers, getExcludeUsers, showInfo, saveAction } = useEvaluateList();
  const { checkPermission } = useCommon();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);

  return (
    <div ref={() => checkPermission("team list", tagRef)}>
      <div ref={tagRef} id='{"tabname": "team list", "data": "evaluate_tab"}'>
        <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2 mb-3 px-3">
          <div className="d-flex align-items-center gap-2 flex-grow-1">
            <h5 className="mb-0">Evaluate List</h5>
          </div>
          <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">
            <button className="sk-btn sk-btn-primary" title='Verify Selected Mapping' onClick={() => saveAction(null, true)}>
                <FontAwesomeIcon icon={faCircleCheck} />
            </button>
            <button className="sk-btn sk-btn-danger" title='Mark Selected as Irrelevant' onClick={() => saveAction(null, false)}>
                <FontAwesomeIcon icon={faCircleXmark} />
            </button>
            <button title='Exclude Employees' className="sk-btn sk-btn-primary" onClick={() => { if (filterValue?.survey?.survey_id) { getExcludeUsers(); setExclude((prev) => ({ ...prev, visible: true, view: false, users: [], api_data: [] })); } else { showInfo("Info", "Please select a survey to exclude employees") } }}>
                <FontAwesomeIcon icon="fa-solid fa-user-xmark" />
            </button>
            <button title='Download Excel' className="sk-btn sk-btn-primary" onClick={getExcelDownload}>
                <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
            </button>
            <button title='Refresh' className="sk-btn sk-btn-primary" onClick={getEvaluatorList}>
                <FontAwesomeIcon icon="fa-solid fa-refresh" />
            </button>
            <button className="sk-btn sk-btn-primary" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                <FontAwesomeIcon icon="fa-solid fa-filter" />
            </button>
            <button title='Add evaluators manually' className='sk-btn sk-btn-primary bg-black text-white' onClick={() => { if (filterValue?.survey?.survey_id) { setShowPopup(true); } else { showInfo("Info", "Please select a survey to add evaluators manually") } }}>
                <FontAwesomeIcon icon="fa-solid fa-plus" /> Add Manually
            </button>
          </div>
        </div>

        <div className="mb-3 ps-3 d-flex gap-2">
          {filterValue?.survey?.survey_id && options?.additional_filters?.map(item => (
            <div key={item?.key} className={`d-flex gap-2 align-items-center px-3 py-1 rounded c-pointer ${filterValue?.additional_filters?.key === item?.key ? "fw-bold" : "fw-semibold"}`} style={{ background: filterValue?.additional_filters?.key === item?.key ? (theme === "dark" ? "transparent" : "#fff6e7") : "transparent", border: filterValue?.additional_filters?.key === item?.key ? "1px solid #f8d79f" : "1px solid lightgrey", color: filterValue?.additional_filters?.key === item?.key ? "#f59e0b" : "grey" }} onClick={() => setFilterValue((prev) => ({ ...prev, additional_filters: item }))}>
              <FontAwesomeIcon icon={`fa-solid fa-${item?.icon}`} />
              <div>{item?.label}</div>
              <div>{filterValue?.additional_filters_counts?.[item?.count_key] > 0 && <>({filterValue?.additional_filters_counts?.[item?.count_key]})</>}</div>
            </div>
          ))}
        </div>
        {filterValue?.survey?.survey_id && <div className="mx-2" style={{ height: "calc(100vh - 160px)", overflowY: "auto" }}>
          <CommonGrid columns={colDef} data={rowData} loader={loader?.grid} expandAll={true} rowHeight={30} headerHeight={50} strippedTable={true} />
        </div>}
        <Dialog visible={showPopup} onHide={() => { setShowPopup(false); setFormValue({}); }} className='modal-xsmall' draggable={false} header="Manual Evaluator Mapping">
          <div>
            <div className='row'>
              <div className='col-md-6 col-12'>
                <label>User</label>
                <MultiSelect
                  placeholder="User"
                  name='users'
                  options={options?.users || []}
                  value={formValue.users}
                  optionLabel="evaluator_user_name"
                  onChange={handleChange}
                  className="sk-multiselect"
                  filter filterInputAutoFocus style={{ width: "100%" }}
                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'users', formValue.users, (val) => setFormValue((prev) => ({ ...prev, users: val })), () => { })} />
              </div>
              <div className='col-md-6 col-12'>
                <label> Evaluator</label>
                <MultiSelect
                  placeholder="Evaluator"
                  name='evaluator'
                  options={options?.users || []}
                  value={formValue.evaluator}
                  optionLabel="evaluator_user_name"
                  onChange={handleChange}
                  className="sk-multiselect"
                  filter filterInputAutoFocus style={{ width: "100%" }}
                  panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'evaluator', formValue.evaluator, (val) => setFormValue((prev) => ({ ...prev, evaluator: val })), () => { })} />
              </div>
            </div>
            <div className='d-flex gap-1 justify-content-end mt-2'>
              <button className="sk-btn sk-btn-primary" onClick={() => { setShowPopup(false); setFormValue({}) }}>Cancel</button>
              {loader?.btn ?
                <button style={{ width: "65px" }} className="sk-btn sk-btn-primary bg-black text-white"> <div class="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                  <span class="sr-only"></span>
                </div></button>
                : <button className="sk-btn sk-btn-primary bg-black text-white" onClick={handleSubmit}>Submit</button>
              }
            </div>
          </div>
        </Dialog>

        <Dialog visible={exclude?.visible} onHide={() => setExclude((prev) => ({ ...prev, visible: false, view: false, users: [], api_data: [] }))} className='modal-small' draggable={false}
          header={() => {
            return (
              <div className='d-flex flex-column gap-2 py-2'>
                <div className='d-flex gap-2 align-items-center text-uppercase' style={{ letterSpacing: "2px" }}><FontAwesomeIcon icon="fa-solid fa-user-xmark" /> Exclude Employees</div>
                <div className='text-secondary' style={{ fontSize: "0.85rem" }}>Select members who should not participate in "{filterValue?.survey?.survey_name}" survey cycle.</div>
              </div>
            );
          }}>
          <div>
            <div className='text-right text-primary c-pointer' onClick={() => setExclude((prev) => ({ ...prev, view: !exclude?.view }))}>{exclude?.view ? "View not Excluded" : "View Excluded"}</div>
            <div style={{ height: "50vh", overflowY: "auto" }}>
              <ListBox className='survey-listbox' options={options?.filtered_exclude_users} optionLabel='user_display_name' multiple filter itemTemplate={optionTemplates?.exclude_users} value={exclude?.users} onChange={(e) => setExclude((prev) => ({ ...prev, users: e.target?.value }))} filterTemplate={optionTemplates?.exclude_users_filter} />
            </div>
            <div className='mt-2 d-flex gap-2 justify-content-end'>
              <button className='sk-btn sk-btn-primary' onClick={() => setExclude((prev) => ({ ...prev, visible: false, view: false, users: [], api_data: [] }))}>Cancel</button>
              <button className='sk-btn sk-btn-danger' onClick={() => saveExcludeUsers()}>Save Exclusion List</button>
            </div>
          </div>
        </Dialog>

        {/* Right Panel Filters Drawer */}
        <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
            <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                <div className="sk-drawer-header">
                    <h5 className="sk-drawer-title">Filters</h5>
                    <div className="d-flex align-items-center gap-2">
                        <button className="sk-drawer-clear-btn" onClick={() => {
                            setFilterValue((prev) => ({
                                ...prev,
                                survey: null,
                                unit: [],
                                users: [],
                                leads: null,
                                projects: [],
                                evaluator: [],
                                status: null,
                                group_by: null,
                                apiCall: true
                            }));
                        }}>Clear All</button>
                        <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                            <FontAwesomeIcon icon="fa-solid fa-xmark" />
                        </button>
                    </div>
                </div>
                <div className="sk-drawer-body">
                    <div className='d-flex flex-column gap-4'>
                        {/* Survey Filter */}
                        <div className="sk-drawer-filter-group">
                            <div className="task-list-filter-label">Survey</div>
                            <Dropdown
                                placeholder="Survey"
                                options={options?.survey_list || []}
                                value={filterValue?.survey}
                                optionLabel="survey_name"
                                onChange={(e) => setFilterValue((prev) => ({ ...prev, survey: e.value, isChange: true }))}
                                className="sk-input-dd w-100"
                                onHide={() => { if (filterValue?.isChange) getEvaluatorList() }}
                                filter filterInputAutoFocus
                                itemTemplate={optionTemplates?.survey}
                            />
                        </div>

                        {/* Dimensions Filter */}
                        <div className="sk-drawer-filter-group">
                            <div className="task-list-filter-label">Dimensions</div>
                            <div className="d-flex flex-column gap-2">
                                <MultiSelect
                                    placeholder="Unit"
                                    options={options?.units || []}
                                    value={filterValue?.unit}
                                    optionLabel="group_name"
                                    onChange={(e) => setFilterValue((prev) => ({ ...prev, unit: e.target.value, isChange: true }))}
                                    onHide={() => { if (filterValue?.isChange) getEvaluatorList() }}
                                    className="sk-input-dd w-100"
                                    filter filterInputAutoFocus
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'unit', filterValue.unit, (val) => setFilterValue((prev) => ({ ...prev, unit: val, isChange: true })), () => { })}
                                />
                                <MultiSelect
                                    placeholder="User"
                                    options={options?.users || []}
                                    value={filterValue?.users}
                                    optionLabel="evaluator_user_name"
                                    onChange={(e) => setFilterValue((prev) => ({ ...prev, users: e.value, isChange: true }))}
                                    className="sk-input-dd w-100"
                                    onHide={() => { if (filterValue?.isChange) getEvaluatorList() }}
                                    filter filterInputAutoFocus
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'users', filterValue.users, (val) => setFilterValue((prev) => ({ ...prev, users: val, isChange: true })), () => { })}
                                />
                                <Dropdown
                                    placeholder="Leads"
                                    options={options?.filtered_leads || []}
                                    value={filterValue?.leads}
                                    optionLabel="user_display_name"
                                    optionValue='user_code'
                                    onChange={(e) => {
                                        if (e.value === undefined) {
                                            getEvaluatorList("leads")
                                            setFilterValue((prev) => ({ ...prev, leads: e.value, isChange: true }))
                                        } else {
                                            setFilterValue((prev) => ({ ...prev, leads: e.value, isChange: true }))
                                        }
                                    }}
                                    className="sk-input-dd w-100"
                                    onHide={() => { if (filterValue?.isChange) getEvaluatorList() }}
                                    filter filterInputAutoFocus
                                    showClear
                                />
                                <MultiSelect
                                    placeholder="Project"
                                    options={options?.projects || []}
                                    value={filterValue?.projects}
                                    optionLabel="project_name"
                                    optionValue='project_id'
                                    onChange={(e) => setFilterValue((prev) => ({ ...prev, projects: e.value, isChange: true }))}
                                    className="sk-input-dd w-100"
                                    onHide={() => { if (filterValue?.isChange) getEvaluatorList() }}
                                    filter filterInputAutoFocus
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'projects', filterValue.projects, (val) => setFilterValue((prev) => ({ ...prev, projects: val, isChange: true })), () => { })}
                                />
                                <MultiSelect
                                    placeholder="Evaluator"
                                    options={options?.users || []}
                                    value={filterValue?.evaluator}
                                    optionLabel="evaluator_user_name"
                                    onChange={(e) => setFilterValue((prev) => ({ ...prev, evaluator: e.value, isChange: true }))}
                                    onHide={() => { if (filterValue?.isChange) getEvaluatorList() }}
                                    className="sk-input-dd w-100"
                                    filter filterInputAutoFocus
                                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'evaluator', filterValue.evaluator, (val) => setFilterValue((prev) => ({ ...prev, evaluator: val, isChange: true })), () => { })}
                                />
                            </div>
                        </div>

                        {/* Status Filter */}
                        <div className="sk-drawer-filter-group">
                            <div className="task-list-filter-label">Status</div>
                            <Dropdown
                                placeholder="Status"
                                options={options?.evaluator_status || []}
                                value={filterValue?.status}
                                optionLabel="status_name"
                                onChange={(e) => { setFilterValue((prev) => ({ ...prev, status: e.target.value, isChange: true })); if (!e.value) { getEvaluatorList("status"); } }}
                                onHide={() => { if (filterValue?.isChange) getEvaluatorList() }}
                                className="sk-input-dd w-100"
                                showClear
                                filter filterInputAutoFocus
                            />
                        </div>

                        {/* Group By Filter */}
                        <div className="sk-drawer-filter-group">
                            <div className="task-list-filter-label">Group By</div>
                            <Dropdown
                                placeholder="Group By"
                                options={options?.group_by || []}
                                value={filterValue?.group_by}
                                onChange={(e) => { setFilterValue((prev) => ({ ...prev, group_by: e.target.value, isChange: true })); if (e?.value === undefined) { getEvaluatorList("group") } }}
                                onHide={() => { if (filterValue?.isChange) getEvaluatorList() }}
                                showClear
                                className="sk-input-dd w-100"
                                filter filterInputAutoFocus
                                itemTemplate={optionTemplates?.group_item}
                                valueTemplate={optionTemplates?.group_value}
                            />
                        </div>
                    </div>
                </div>
                <div className="sk-drawer-footer">
                    <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                        getEvaluatorList();
                        setShowFiltersDrawer(false);
                    }}>Apply Filters</button>
                </div>
            </div>
        </div>
      </div >
    </div >
  )
}

export default EvaluateList